import React from 'react';
import ZoneCard from './ZoneCard.jsx';

if (typeof document !== 'undefined' && !document.getElementById('wr-cards-css')) {
  const s = document.createElement('style');
  s.id = 'wr-cards-css';
  s.textContent = `
    .wr-zone-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 16px;
    }
    @media (max-width: 1024px) { .wr-zone-grid { grid-template-columns: repeat(3, 1fr); } }
    @media (max-width: 600px)  { .wr-zone-grid { grid-template-columns: 1fr; } }
  `;
  document.head.appendChild(s);
}

const RISK_ORDER = { high: 0, elevated: 1, advisory: 2 };

export default function ZoneSummaryCards({ zones, incidents, onViewIncidents }) {
  const cutoff7d = Date.now() - 7 * 24 * 60 * 60 * 1000;

  const sorted = [...(zones || [])].sort((a, b) => {
    const rDiff = (RISK_ORDER[a.risk_level] ?? 9) - (RISK_ORDER[b.risk_level] ?? 9);
    if (rDiff !== 0) return rDiff;
    // Within same risk level, sort by 7d incident count desc
    const aCount = (incidents || []).filter(i => i.zone_id === a.id && new Date(i.date).getTime() > cutoff7d).length;
    const bCount = (incidents || []).filter(i => i.zone_id === b.id && new Date(i.date).getTime() > cutoff7d).length;
    return bCount - aCount;
  });

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 16, fontWeight: 600, color: '#fff' }}>
          Zone Risk Summary
        </div>
        <div style={{ fontSize: 11, color: '#8892a5', marginTop: 2 }}>
          {sorted.length} JWC Listed Areas · sorted by risk level then recent incident count
        </div>
      </div>
      <div className="wr-zone-grid">
        {sorted.map(zone => (
          <ZoneCard
            key={zone.id}
            zone={zone}
            incidents={incidents}
            onViewIncidents={onViewIncidents}
          />
        ))}
      </div>
    </div>
  );
}
